// O que a conexão de fato faz — perguntado ao backend, não deduzido do canal.
//
// Antes cada tela decidia por lista fixa
// (`["facebook","instagram","whatsapp_official"].includes(channel)`), e cada
// canal novo era mais um item em cada lista espalhada pelo código. Pior: a
// lista dizia de que CANAL a conexão é, nunca o que ela FAZ — o WhatsApp
// atendido pela WAHA não arquiva conversa, e o do whaileys arquiva, e os dois
// têm `channel: "whatsapp"`.
//
// O backend declara em `providers/Channels/types.ts` e devolve em
// `canal.capabilities`, tanto em `GET /whatsapp` quanto em `GET /whatsapp/:id`.
// Fase 1.3 do plano de execução.

// `null` = a conexão não tem adapter (Zernio) e o backend não sabe responder.
// Nesse caso NÃO se esconde nada: o comportamento antigo continua, e esconder
// por falta de resposta tiraria botão que hoje funciona.
export const capacidadesDaConexao = (whatsApp) =>
  whatsApp?.canal?.capabilities || null;

// A conexão faz isto? Sem resposta do backend, assume que sim — ver acima.
export const conexaoFaz = (whatsApp, capacidade) => {
  const capacidades = capacidadesDaConexao(whatsApp);

  if (!capacidades) return true;

  return Boolean(capacidades[capacidade]);
};

// A conexão deste atendimento, achada na lista que a tela já tem em mãos.
export const conexaoDoTicket = (whatsApps, ticket) =>
  (whatsApps || []).find((w) => w.id === ticket?.whatsappId) || null;

// O atendimento aceita esta operação?
export const ticketFaz = (whatsApps, ticket, capacidade) =>
  conexaoFaz(conexaoDoTicket(whatsApps, ticket), capacidade);

// Estados em que a conexão não entrega mensagem. Lista do que é sabidamente
// ruim, e não `status !== "CONNECTED"`: canal sem sessão (Zernio, e qualquer
// integração futura) pode nem preencher o status, e um vazio viraria alarme
// falso — com o compositor trancado por engano.
const FORA_DO_AR = [
  "DISCONNECTED",
  "TIMEOUT",
  "OPENING",
  "PAIRING",
  "qrcode",
];

// A conexão está fora do ar? Serve para avisar ANTES do envio: sem isto o
// atendente digita, dá enter e acredita que falou com o cliente.
export const conexaoForaDoAr = (whatsApp) =>
  Boolean(whatsApp) && FORA_DO_AR.includes(whatsApp.status);

export default conexaoFaz;
